export const selectSchedulingLoader = (state) => state?.scheduling?.isLoading;
export const selectInterviewDetails = (state) =>
  state?.scheduling?.interviewDetails;
export const selectCreatedInterviewDetails = (state) =>
  state?.scheduling?.createdInterviewDetails;
export const selectEventFetchId = (state) => state?.scheduling?.eventFetchId;
export const selectInterviewersEvents = (state) =>
  state?.scheduling?.interviewersEvents;
export const selectInterviewersList = (state) =>
  state?.scheduling?.interviewersList;
export const selectWeekRange = (state) => state?.scheduling?.weekRange;
export const selectDuration = (state) => state?.scheduling?.duration;
export const selectEvents = (state) => state?.scheduling?.events;
export const selectInterviewerId = (state) =>
  state?.scheduling?.suggestedInterviewId;
export const selectTimezone = (state) => state?.scheduling?.timezone;
